import * as constant from "../constants/PlanConstants";
import * as constant2 from "../constants/SessionConstant";
import * as constant3 from "../constants/RefferalConstamt";
import * as constant4 from "../constants/SpeakerConstant";

const initialState = {
  user: {},
  pandingRequest: null,
  upcomingSession: null,
  pastSession: null,
  learnerRefferalData: null,
  learnerWalletHistory: null,
  sessionDocs: {
    notes: null,
    sessionTaken: 0,
  },
  videos: null,
  country: null,
  timezone: null,
  calling_code: null,
  favoriteSpeakers: null,
};

export const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case constant.LOAD_USER:
      console.log(action);
      return {
        ...state,
        user: action.payload,
      };
    //Learner refferal
    case constant3.GET_REFFERAL_DATA:
      console.log(action.payload);
      return {
        ...state,
        learnerRefferalData: action.payload,
      };
    //Learner wallet history
    case constant3.GET_WALLET_HISTORY:
      console.log(action.payload);
      return {
        ...state,
        learnerWalletHistory: action.payload,
      };
    //teacher panding req
    case constant2.FETCH_TEACHER_PENDING_REQUEST:
      return {
        ...state,
        pandingRequest: action.payload.sessions,
      };
    //teacher upcoming session
    case (constant2, constant2.TEACHER_UPCOMING_SESSION):
      if (state.upcomingSession === null) {
        return {
          ...state,
          upcomingSession: action.payload.sessions,
        };
      } else {
        return {
          ...state,
          upcomingSession: [
            ...state.upcomingSession,
            ...action.payload.sessions,
          ],
        };
      }
    //teacher past session
    case constant2.TEACHER_PAST_SESSION:
      if (state.pastSession === null) {
        return {
          ...state,
          pastSession: action.payload.sessions,
        };
      } else {
        return {
          ...state,
          pastSession: [...state.pastSession, ...action.payload.sessions],
        };
      }
    //teacher past session
    case constant2.TEACHER_DECLINE:
      console.log(action.payload);
      return {
        ...state,
        pandingRequest: state.pandingRequest.filter(
          (data) => data._id != action.payload
        ),
        // pastSession: action.payload.sessions
      };
    case constant.GET_NOTES:
      return {
        ...state,
        sessionDocs: {
          notes: action.payload.note,
          sessionTaken: action.payload.sessionTaken,
        },
      };
    case constant3.GET_ViDEOS:
      return {
        ...state,
        videos: action.payload.libraries,
      };
    case constant.GLOBAL_UPDATE:
      return {
        ...state,
        country: action.payload.country,
        timezone: action.payload.timezone,
        calling_code: action.payload.calling_code,
      };
    case constant4.ADD_FAVORITE_SPEAKER:
      console.log(action.payload);
      if (state.favoriteSpeakers !== null) {
        let filter = state.favoriteSpeakers.find(
          (x) => x._id === action.payload._id
        );
        if (filter) {
          return {...state}
        } else {
          return {
            ...state,
            favoriteSpeakers: [...state.favoriteSpeakers, action.payload],
          };
        }
      } else {
        return {
          ...state,
          favoriteSpeakers: [action.payload],
        };
      }
      case constant4.GET_FAVORITE_SPEAKERS:
        return {
          ...state,
          favoriteSpeakers: action.payload,
        };
      case constant4.REMOVE_FAVORITE_SPEAKER:
        return {
          ...state,
          favoriteSpeakers: state.favoriteSpeakers.filter(speaker => speaker._id !== action.payload),
        };
    //default
    default:
      return state;
  }
};
